export var LOADABLE_COMPONENTS_MAP = {
    Header: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "Header" */
        './modules/_core/components/Header/Header');
    },
    TextMessage: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "TextMessage" */
        './modules/chat/components/Messages/TextMessage');
    },
    CarouselWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "CarouselWidget" */
        './modules/chat/components/CarouselWidget/CarouselWidget');
    },
    GenericFormWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "GenericFormWidget" */
        './modules/chat/components/GenericFormWidget/GenericFormWidget');
    },
    NotificationWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "NotificationWidget" */
        './modules/chat/components/NotificationWidget/NotificationWidget');
    },
    TilesWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "TilesWidget" */
        './modules/chat/components/TilesWidget/TilesWidget');
    },
    AnnouncementWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "AnnouncementWidget" */
        './modules/chat/components/AnnouncementWidget');
    },
    NewConversationWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "NewConversationWidget" */
        './modules/chat/components/NewConversationWidget');
    },
    ChatbotRatingWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "ChatbotRatingWidget" */
        './modules/chat/components/ChatbotRatingWidget/ChatbotRatingWidget');
    },
    CarouselSearchWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "CarouselSearchWidget" */
        './modules/chat/components/CarouselSearchWidget/CarouselSearchWidget');
    },
    NPSRatingWidget: function () {
        return import(
        /* webpackPrefetch: true, webpackChunkName: "NPSRatingWidget" */
        './modules/chat/components/NPSRatingWidget/NPSRatingWidget');
    },
};
